export type GetPartnerRequest = {
  ptnrId: string;
};
